export function hasAdminPrivileges (state, getters) {
	return clubId => getters[`hasRole`](clubId, `club:admin`) || getters[`hasRole`](clubId, `club:owner`);
}
